import React from 'react';
import AdminSkillGroupListContainer from '@src/components/administration/AdminSkillGroupListContainer';

const AdminSkillGroupListPage = () => <AdminSkillGroupListContainer />;

export default AdminSkillGroupListPage;
